export default __webpack_public_path__ + "static/media/illustration-features-tab-3.a4206aab.svg";